import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Tabs from "../../../Reuseable/Tabs/Tabs";
import BasicDetails from "./BasicDetails/BasicDetails";
import LoanDetails from "./LoanDetails/LoanDetails";
import Placeholder from "./Placeholder/Placeholder";
import { useSelector } from "react-redux";
import Feedback from "./Feedback/Feedback";
import AgencyFeedback from "./AgencyFeedback/AgencyFeedback";
/* The shell used to be styled only because BasicDetails happened to import
   this stylesheet, so the tab rail was unstyled until that tab had loaded. */
import "./AllocationCaseDetails.scss";

const AllocationCaseDetailsPage = () => {
  const defaultTab = localStorage.getItem("allocation-tab") || "basicDetail";

  const [selectedTab, setSelectedTab] = useState(
    defaultTab === "placeholder" ? "feedback" : defaultTab
  );
  const { user } = useSelector((state) => state.auth);
  const { state } = useLocation();

  const tabOptions = [
    { label: "Basic Details", value: "basicDetail" },
    { label: "Loan Details", value: "loanDetail" },
    { label: "Feedback", value: "feedback" },
  ];

  useEffect(() => {
    localStorage.setItem("allocation-tab", selectedTab);
  }, [selectedTab]);

  const renderTabContent = () => {
    switch (selectedTab) {
      case "basicDetail":
        return <BasicDetails data={state} />;
      case "loanDetail":
        return <LoanDetails data={state} />;
      case "feedback":
        return user?.is_tc ? (
          <Feedback data={state} />
        ) : (
          <AgencyFeedback data={state} />
        );
      default:
        return null;
    }
  };

  return (
    <div className="mainWrapperAllocation">
      <Tabs
        options={tabOptions}
        active={selectedTab}
        onChange={(val) => setSelectedTab(val)}
        // showSelector={false}
        selectorBreakpoint={620}
      />
      {renderTabContent()}
    </div>
  );
};

export default AllocationCaseDetailsPage;
